// Catalog of plot objects. Stage 2a: 12 core types mapped to SP 53.13330 /
// SanPiN / SP 4.13130 severity classes (fire-resistance A/B/V) — relevant for
// Stage 4 norms validator, wired in here so the validator has a single source.
//
// Shape: rectangle for Stage 2a. Future: polygon, polyline (fence, path).
// All sizes in metres. hasHeight=true means the object casts a shadow (Stage 3).

export const CATEGORIES = {
  dwelling: "Жилые строения",
  utility: "Хозяйственные",
  sanitary: "Санитарные и вода",
  leisure: "Отдых",
  garden: "Сад и огород",
  infrastructure: "Инфраструктура",
}

export const OBJECT_TYPES = [
  {
    id: "house",
    name: "Жилой дом",
    category: "dwelling",
    defaultSizeM: { width: 10, height: 12 },
    defaultHeightM: 6,
    hasHeight: true,
    fireClass: "V",
    fillColor: "#fde68a",
    strokeColor: "#b45309",
  },
  {
    id: "garage",
    name: "Гараж",
    category: "utility",
    defaultSizeM: { width: 6, height: 4 },
    defaultHeightM: 3,
    hasHeight: true,
    fireClass: "B",
    fillColor: "#e5e7eb",
    strokeColor: "#374151",
  },
  {
    id: "bathhouse",
    name: "Баня",
    category: "utility",
    defaultSizeM: { width: 6, height: 5 },
    defaultHeightM: 3,
    hasHeight: true,
    fireClass: "V",
    fillColor: "#fed7aa",
    strokeColor: "#9a3412",
  },
  {
    id: "shed",
    name: "Сарай",
    category: "utility",
    defaultSizeM: { width: 4, height: 3 },
    defaultHeightM: 2.5,
    hasHeight: true,
    fireClass: "V",
    fillColor: "#d6d3d1",
    strokeColor: "#57534e",
  },
  {
    id: "greenhouse",
    name: "Теплица",
    category: "garden",
    defaultSizeM: { width: 3, height: 6 },
    defaultHeightM: 2.5,
    hasHeight: true,
    fireClass: "B",
    fillColor: "#bbf7d0",
    strokeColor: "#166534",
  },
  {
    id: "gazebo",
    name: "Беседка",
    category: "leisure",
    defaultSizeM: { width: 3, height: 3 },
    defaultHeightM: 2.5,
    hasHeight: true,
    fireClass: "V",
    fillColor: "#fef3c7",
    strokeColor: "#92400e",
  },
  {
    id: "toilet",
    name: "Туалет",
    category: "sanitary",
    defaultSizeM: { width: 1.2, height: 1 },
    defaultHeightM: 2,
    hasHeight: true,
    fireClass: "V",
    fillColor: "#fae8ff",
    strokeColor: "#86198f",
  },
  {
    id: "well",
    name: "Колодец",
    category: "sanitary",
    defaultSizeM: { width: 1.5, height: 1.5 },
    defaultHeightM: 0.5,
    hasHeight: false,
    fillColor: "#bfdbfe",
    strokeColor: "#1e3a8a",
  },
  {
    id: "septic",
    name: "Септик",
    category: "sanitary",
    defaultSizeM: { width: 2, height: 2 },
    defaultHeightM: 0,
    hasHeight: false,
    fillColor: "#e0e7ff",
    strokeColor: "#3730a3",
  },
  {
    id: "fence",
    name: "Забор",
    category: "infrastructure",
    defaultSizeM: { width: 0.3, height: 20 },
    defaultHeightM: 2,
    hasHeight: true,
    fillColor: "#a8a29e",
    strokeColor: "#44403c",
  },
  {
    id: "path",
    name: "Дорожка",
    category: "infrastructure",
    defaultSizeM: { width: 1, height: 8 },
    defaultHeightM: 0,
    hasHeight: false,
    fillColor: "#d4d4d8",
    strokeColor: "#71717a",
  },
  {
    id: "tree",
    name: "Дерево",
    category: "garden",
    defaultSizeM: { width: 4, height: 4 },
    defaultHeightM: 5,
    hasHeight: true,
    crownRadiusM: 2,
    fillColor: "#bbf7d0",
    strokeColor: "#166534",
  },
]

export function typeById(id) {
  return OBJECT_TYPES.find((t) => t.id === id) ?? null
}

export function typesByCategory() {
  const grouped = Object.fromEntries(Object.keys(CATEGORIES).map((k) => [k, []]))
  for (const t of OBJECT_TYPES) grouped[t.category].push(t)
  return grouped
}
